/* eslint-disable react/destructuring-assignment */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { Input, Button } from '../../components';
import { insereDados, clear4to8 } from '../../store/actions/questionario-actions';

function Main(props) {
  const [outro, setOutro] = useState('');
  const onChange = (event) => {
    const { name, value } = event.target;
    props.insereDados(name, value);
  };
  const [valid, setValid] = useState({});
  const schema = Yup.object().shape({
    envolvido: Yup.string()
      .min(2, 'Esse campo é obrigatório.')
      .required('Esse campo é obrigatório.'),
    outro: Yup.string()
      .min(6, 'Por favor, especificar o campo outro')
      .required('Por favor, especificar o campo outro'),
  });
  const goProximaQuestao = (e) => {
    e.preventDefault();
    let dados = '';
    if (outro) {
      dados = {
        envolvido: props.dados.envolvido,
        outro: props.dados.envolvido,
      };
    } else {
      dados = {
        envolvido: props.dados.envolvido,
        outro: '123456789',
      };
    }

    schema.validate(dados).then(
      () => {
        props.history.push('/questao51');
      },
    ).catch((err) => {
      setValid(err);
    });
  };
  const clear = async () => {
    await props.clear4to8();
  };
  useEffect(() => {
    clear();
    // eslint-disable-next-line
  }, []);
  return (
    <form onSubmit={goProximaQuestao}>
      <h3>4 - O funcionário envolvido é:</h3>
      <b>Caso responda que sim, informe quem é o funcionário e/ou qual o cargo ele ocupa.</b><br />
      <Input
        type="radio"
        name="envolvido"
        checked={props.dados.envolvido === 'funcionario'}
        value="funcionario"
        onChange={onChange}
      />
      <span>Funcionário (agência ou área administrativa)</span><br />
      <Input
        type="radio"
        name="envolvido"
        value="gerente"
        checked={props.dados.envolvido === 'gerente'}
        onChange={onChange}
      />
      <span>Gerente</span><br />
      <Input
        type="radio"
        name="envolvido"
        value="superintendente"
        checked={props.dados.envolvido === 'superintendente'}
        onChange={onChange}
      />
      <span>Superintendente</span><br />
      <Input
        type="radio"
        name="envolvido"
        value="presidente"
        checked={props.dados.envolvido === 'presidente'}
        onChange={onChange}
      />
      <span>Presidente, Vice-Presidente ou Diretor</span><br />
      <Input
        type="radio"
        name="envolvido"
        value="conselho"
        checked={props.dados.envolvido === 'conselho'}
        onChange={onChange}
      />
      <span>Membro do Conselho de Administração, Conselho Fiscal ou demais Comitês Institucionais</span><br />
      <br />
      <Input
        type="radio"
        name="envolvido"
        value="outro"
        onChange={(e) => {
          onChange(e);
          setOutro(true);
        }}
      />
      <span>Outro (especificar):</span>
      <Input
        name="envolvido"
        id="outro"
        type="text"
        onChange={e => props.insereDados('envolvido', `outros:${e.target.value}`)}
      /><br />
      <span className="worning">{valid.errors && valid.errors[0]}</span><br />
      <Button type="button" onClick={() => props.history.push('/questao31')}>QUESTÃO ANTERIOR</Button>
      <Button type="submit" className="button">PRÓXIMA QUESTÃO</Button>
    </form>
  );
}
const mapStateToProps = state => (
  {
    dados: state.QuestionarioReducers,
  }
);
export default connect(mapStateToProps, { insereDados, clear4to8 })(Main);
